import * as PropTypes from "prop-types";
import PencilSvg from "./pencil.svg";
import Icon from "./Icon";

export default function EditIcon({ className, style, onClick }) {
  const localStyle = {
    height: "1.5rem",
    width: "1.5rem",
    cursor: "pointer",
    ...style,
  };

  return (
    <Icon
      src={PencilSvg}
      className={className}
      style={localStyle}
      onClick={onClick}
    />
  );
}

EditIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

EditIcon.defaultProps = {
  className: "",
  style: {},
};
